import React from "react";
import { useSelector } from "react-redux";
import { Button } from "antd";
import ButtonGroup from "antd/lib/button/button-group";
import { LeftOutlined, RightOutlined, SaveOutlined } from "@ant-design/icons";

import { i18, trb } from "@utilities";
import { selectCurrentStep } from "@redux";
import { TOTAL_STEPS } from "@config";

// minus one to match indexing
const maxSteps = TOTAL_STEPS - 1;

export const ActionButtons = React.memo(
  ({ handlePrevStep, isLoading = false, submitDisabled = false, handleNextStep }) => {
    const currentStep = useSelector(selectCurrentStep);
    return (
      <div className="row">
        <div className="col-12 pt-3">
          <ButtonGroup>
            {currentStep !== 0 && (
              <Button
                onClick={handlePrevStep}
                loading={isLoading}
                htmlType="submit"
                name="prev"
              >
                {trb(i18.Buttons.PrevStep)}
              </Button>
            )}
            {currentStep !== maxSteps && (
              <Button
                htmlType="submit"
                type="primary"
                name="next"
                loading={isLoading}
                onClick={handleNextStep}
              >
                {trb(i18.Buttons.NextStep)} <RightOutlined />
              </Button>
            )}
            {currentStep === maxSteps && (
              <Button
                htmlType="submit"
                type="primary"
                name="next"
                icon={<SaveOutlined />}
                loading={isLoading}
                disabled={submitDisabled}
                onClick={handleNextStep}
              >
                {trb(i18.Buttons.Submit)}
              </Button>
            )}
          </ButtonGroup>
        </div>
      </div>
    );
  }
);
